import { render, staticRenderFns } from "./PDFView.vue?vue&type=template&id=01670ee5&scoped=true"
import script from "./PDFView.vue?vue&type=script&lang=js"
export * from "./PDFView.vue?vue&type=script&lang=js"
import style0 from "./PDFView.vue?vue&type=style&index=0&id=01670ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01670ee5",
  null
  
)

export default component.exports